export default {
  "Container": "_Container_19lax_1",
  "ContentWrapper": "_ContentWrapper_19lax_5",
  "SidebarWrapper": "_SidebarWrapper_19lax_11",
  "Content": "_Content_19lax_5"
};import "ni:sha-256;jAT2DM2R67fitX0yghDL_qrXqCXtMeXqsRCXDDvCRuk";